import React, {useRef, useEffect, useState} from "react";
import Select from "react-select";
import makeAnimated from "react-select/animated";
import CreatableSelect from "react-select/creatable";
import AsyncSelect from "react-select/async";
import useWindowDimension from "../common/useWindowDimension";
import {calculateDropdownHeight} from "../../util/common";
import "./Dropdown.scss";

const customStyles = (props) => ({
  option: (provided, state) => ({
    ...provided,
    backgroundColor: state.isSelected ? "#d2d2d2" : "white",
    color: state.isSelected ? "black" : "#242424",
    margin: "1px 0",
    "&:hover": {
      backgroundColor: !state.isSelected ? "#F5F5F5" : null,
    },
  }),
  singleValue: (provided) => ({
    ...provided,
    color: "#242424",
    // transition: 'none !important',
  }),
  control: (provided) => ({
    ...provided,
    // borderColor: props.error ? "red" : provided.borderColor,
    borderRadius: "4px",
    // padding: "3px",
    borderWidth: 0,
    boxShadow: "none",
  }),
  indicatorSeparator: () => ({}),
  placeholder: (provided) => ({
    ...provided,
    whiteSpace: "nowrap",
    textOverflow: "ellipsis",
    overflow: "hidden",
    width: "100%",
  }),
  container: (provided) => ({
    ...provided,
    width: "100%",
  }),
  menu: (provided) => ({
    ...provided,
    marginTop: "1px",
  }),
});

const Dropdown = ({
  options,
  placeholder = "",
  value,
  onChange,
  id,
  disabled = false,
  loader = false,
  multiple = false,
  type = "dropdown",
  error = false,
  isClearable = false,
  isSearchable,
  scrollableHeightinPixel,
  loadOptions,
  scrollBottom = null,
  from,
}) => {
  const [height] = useWindowDimension({from});
  const [dropdownMaxMenuHeight, setDropdownMaxMenuHeight] = useState(100);
  useEffect(() => {
    if (from === "office_bu") {
      const dropDownMenuHeight = calculateDropdownHeight(
        "office-store-main-wrap"
      );
      setDropdownMaxMenuHeight(dropDownMenuHeight);
    }
  }, [height, from]);

  const [inputValue, setInputValue] = useState("");
  const searchTextRef = useRef("");
  const pageRef = useRef(0);
  const [loading, setLoading] = useState(false);
  const hasMore = useRef(true);

  useEffect(() => {
    if (loading) setLoading(false);
  }, [options]);

  const handleInputChange = (newValue) => {
    setInputValue(newValue);
    return newValue;
  };
  const isCreateDropdown = type === "createDropdown";
  const isAsyncSearch = type === "asyncDropdown";
  const commonProps = {
    components: makeAnimated(),
    styles: customStyles({error}),
    isMulti: multiple,
    id: id,
    isSearchable: isSearchable === "false" ? false : true,
    placeholder: placeholder,
    isDisabled: disabled,
    maxMenuHeight: scrollableHeightinPixel,
    closeMenuOnSelect: !multiple,
    isClearable: multiple ? true : isClearable,
    value: value,
    onChange: (data) => onChange({id: id, option: data}),
  };

  const specificProps = {
    isLoading: loader,
    options: options,
    noOptionsMessage: () => "No Results Found",
  };
  const asyncRequest = (inputValue, callback) => {
    searchTextRef.current = inputValue;
    pageRef.current = 0;
    hasMore.current = true;
    return loadOptions(inputValue, callback, {offset: pageRef.current * 10});
  };

  const menuScrollBottom = scrollBottom
    ? () => scrollBottom(searchTextRef.current)
    : () => {
        if (hasMore.current) {
          setLoading(true);
          pageRef.current = pageRef.current + 1;
          loadOptions(searchTextRef.current, checkHasMore, {
            offset: pageRef.current * 10,
          });
        }
      };
  const checkHasMore = (totalResult, result) => {
    setLoading(false);
    if (!result?.length) hasMore.current = false;
  };

  return (
    <React.Fragment>
      <div
        className={`input-search-wrap ${loader ? "input-search-loader" : ""}`}
      >
        {Object.keys({...commonProps})?.length > 0 &&
          (isCreateDropdown ? (
            <CreatableSelect {...commonProps} {...specificProps} />
          ) : isAsyncSearch ? (
            <AsyncSelect
              {...commonProps}
              onMenuScrollToBottom={menuScrollBottom}
              loadOptions={loadOptions ? asyncRequest : () => null}
              defaultOptions={options}
              noOptionsMessage={() =>
                inputValue?.length ? "No Results Found" : "Search For Store's"
              }
              onInputChange={handleInputChange}
              isLoading={loader}
              // cacheOptions
            />
          ) : (
            <Select
              {...commonProps}
              {...specificProps}
              {...(from === "office_bu" && {
                maxMenuHeight: dropdownMaxMenuHeight,
              })}
              open
              classNamePrefix="dropdown-select"
            />
          ))}
      </div>
    </React.Fragment>
  );
};

export default Dropdown;
